import { render, staticRenderFns } from "./UserProfile.html?vue&type=template&id=bf4eeef2&scoped=true&"
import script from "./UserProfile.js?vue&type=script&lang=js&"
export * from "./UserProfile.js?vue&type=script&lang=js&"
import style0 from "./UserProfile.scss?vue&type=style&index=0&id=bf4eeef2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf4eeef2",
  null
  
)

export default component.exports